export default {
    data() {
        return {
            standalonePolicyComputedWarningThrown: false,
            convertedFromMSTComputedWarningThrown: false,
        };
    },
    methods: {
        isStandalonePolicyCheck(submission) {
           if (submission) {
               if (submission.risk_structure) {
                   return submission.risk_structure === 'standalone_policy';
               }

               console.warn('isStandalonePolicyCheck - risk structure not found on submission!');
           } else {
               console.warn('isStandalonePolicyCheck - submission not found!');
           }

           return false;
        },
        isConvertedFromManualSubmissionCheck(submission) {
            if (submission) {
                return submission.manual_submission_tracker !== null && submission.manual_submission_tracker !== undefined;
            }
            console.warn('isConvertedFromManualSubmissionCheck - submission not found!');

            return false;
        },

    },
    computed: {
        isStandalonePolicy() {
            if (this.submission) {
                return this.isStandalonePolicyCheck(this.submission);
            }
            if (!this.standalonePolicyComputedWarningThrown) {
                this.standalonePolicyComputedWarningThrown = true;
                console.warn('isStandalonePolicy computed - submission not found!');
            }
            return false;
        },
        isConvertedFromManualSubmission() {
            if (this.submission) {
                return this.isConvertedFromManualSubmissionCheck(this.submission);
            }
            if (!this.convertedFromMSTComputedWarningThrown) {
                this.convertedFromMSTComputedWarningThrown = true;
                console.warn('isConvertedFromManualSubmission computed - submission not found!');
            }
            return false;
        },
    }
};

